import 'imagesloaded';
import 'jquery-match-height';
import 'slick-carousel';

const $featuredSection = $('section.featured');
if ($featuredSection.length) {
  const self = {};

  /** Initialise the module. */
  self.initialise = function initialise() {
    $featuredSection.imagesLoaded(() => {
      $('.featured-item .featured-image, .featured-item .featured-description').matchHeight({
        byRow: false,
        property: 'height',
        target: null,
        remove: false,
      });
    });

    const $featureContainers = $('.js-featured-item-container');

    $featureContainers.click(function click() {
      const $this = $(this);
      if ($this.hasClass('flipped')) {
        $this.removeClass('flipped');
      } else {
        $featureContainers.removeClass('flipped');
        $this.addClass('flipped');
      }
    });

    if ($featureContainers.length === 3) {
      $featureContainers.css('width', '32%');
    }
  };

  self.initialise();
}
